export default "__VITE_ASSET__CQmkuIi4__"